import { isSumaho } from '../common/isSumaho';

export function menu() {
  if (isSumaho()) {
    $('body').prepend(`
      <div class="menu">
        <div class="menu-outer">
          <button data-menuclose></button>
          <div class="menu-cont">
            <div class="menu-bx">
              <button data-rsv class="menu-search">空室検索</button>
              <a href="https://booking.iconia.co.jp/booking/result?code=acebb224-edd1-43a0-a2c6-27133aa40c01&type=plan&order=recommended&is_including_occupied=false&search_type=undated&nights=1&adults=2&kids_tiers=%5B%5D&room_count=1&mcp_currency=JPY" target="_blank" class="menu-plan">プラン一覧</a>
              <a href="https://iconia.co.jp/cancellation/?cancelhotelid=acebb224-edd1-43a0-a2c6-27133aa40c01" target="_blank" class="menu-link">予約確認・キャンセル</a>
              <a class="menu-tel" href="tel:050-5443-6483">TEL : 050-5443-6483</a>
            </div>
          </div>
        </div>
      </div>
    `);
    $('.menu-cont').prepend($('.header-nav').removeClass('header-nav').addClass('menu-nav'));
    $('[data-menuclose],.menu-nav a').on('click', function () {
      $('.menu').hide();
    });
  }
}
